// Partial enhancement: Add a visual UI to define condition type for score dependencies
// Full backend logic and storage in DynamoDB can be implemented later

// ✅ Step 1: Add this component to your file

import React, { useState } from 'react';

const ConditionRuleBuilder = ({ rules, setRules, promptMaster }) => {
  const handleAddRule = () => {
    setRules([...rules, { targetCategory: '', conditionType: 'OR', conditionCategories: [], overrideScore: 0 }]);
  };

  const handleRuleChange = (index, field, value) => {
    const updated = [...rules];
    updated[index][field] = value;
    setRules(updated);
  };

  const handleConditionCategoryToggle = (index, category) => {
    const updated = [...rules];
    const list = updated[index].conditionCategories;
    updated[index].conditionCategories = list.includes(category)
      ? list.filter((c) => c !== category)
      : [...list, category];
    setRules(updated);
  };

  const handleDeleteRule = (index) => {
    const updated = [...rules];
    updated.splice(index, 1);
    setRules(updated);
  };

  return (
    <div className="mb-6">
      <h4 className="font-semibold mb-2">Conditional Score Rules</h4>
      {rules.map((rule, index) => (
        <div key={index} className="p-4 border border-gray-300 rounded mb-4">
          <label className="block mb-1">Target Category:</label>
          <select
            className="p-2 border w-full rounded mb-2"
            value={rule.targetCategory}
            onChange={(e) => handleRuleChange(index, 'targetCategory', e.target.value)}
          >
            <option value="">-- Select --</option>
            {promptMaster.map((p, i) => (
              <option key={i} value={p.promptcategory}>{p.promptcategory}</option>
            ))}
          </select>

          <label className="block mb-1">Condition Type:</label>
          <select
            className="p-2 border w-full rounded mb-2"
            value={rule.conditionType}
            onChange={(e) => handleRuleChange(index, 'conditionType', e.target.value)}
          >
            <option value="OR">OR</option>
            <option value="AND">AND</option>
          </select>

          <label className="block mb-1">Condition Categories:</label>
          <div className="flex flex-wrap mb-2">
            {promptMaster.map((p, i) => (
              <div
                key={i}
                onClick={() => handleConditionCategoryToggle(index, p.promptcategory)}
                className={`cursor-pointer m-1 px-2 py-1 rounded border text-sm ${
                  rule.conditionCategories.includes(p.promptcategory)
                    ? 'bg-green-200 border-green-400'
                    : 'bg-gray-100 border-gray-300'
                }`}
              >
                {p.promptcategory}
              </div>
            ))}
          </div>

          <label className="block mb-1">Override Score:</label>
          <input
            type="number"
            className="p-2 border w-full rounded"
            value={rule.overrideScore}
            onChange={(e) => handleRuleChange(index, 'overrideScore', parseFloat(e.target.value))}
          />

          <button
            className="mt-3 px-3 py-1 bg-red-500 text-white rounded"
            onClick={() => handleDeleteRule(index)}
          >
            Delete Rule
          </button>
        </div>
      ))}
      <button onClick={handleAddRule} className="px-4 py-2 bg-blue-600 text-white rounded">
        Add Rule
      </button>
    </div>
  );
};

export default ConditionRuleBuilder;

